import React, { useReducer, createContext, useEffect, Suspense, useMemo, useState } from "react";
import "./assets/css/App.css";
import { appReducer } from "./reducers/app";
import api from "./api/endpoints";
import { LoadingOutlined } from "@ant-design/icons";

// Code Splitting: Lazy load main pages
const Login = React.lazy(() => import("./pages/Login"));
const Home = React.lazy(() => import("./pages/Home"));

export const AppContext = createContext();

// Simple loading component for initial chunk fetch
const MainLoading = () => (
  <div style={{ 
    height: '100vh', 
    width: '100vw', 
    background: '#020205', 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center',
    color: '#00f3ff'
  }}>
    <LoadingOutlined style={{ fontSize: 48 }} spin />
  </div>
);

function App() {
  const initialState = {
    isAuth: false,
    token: null,
    user: null,
    profile: null,
    update_count: 0,
    breadcrumbItems: [],
  };

  const [state, dispatch] = useReducer(appReducer, initialState);
  // Block rendering until we've checked for a session
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);

  const updateApp = async () => {
    const token = JSON.parse(localStorage.getItem("token"));
    const user = JSON.parse(localStorage.getItem("user"));

    if (user && token) {
      try {
        await api.authentication.retrieve(user.username).then((x) => {
          dispatch({
            type: "UPDATE",
            payload: x,
          });
        });
      } catch (error) {
        console.error("Session validation failed:", error);
        // Optional: clear invalid tokens here if needed
      } finally {
        // Checked and done (success or fail)
        setIsCheckingAuth(false);
      }
    } else {
      // No token found, stop checking and show Login
      setIsCheckingAuth(false);
    }
  };

  useEffect(() => {
    updateApp();
    // eslint-disable-next-line
  }, [state.update_count]);

  // Memoize context value to prevent unnecessary re-renders of children
  const contextValue = useMemo(() => ({ state, dispatch }), [state, dispatch]);

  if (isCheckingAuth) {
    return <MainLoading />;
  }

  return (
    <AppContext.Provider value={contextValue}>
      <Suspense fallback={<MainLoading />}>
        {state.isAuth ? <Home /> : <Login />}
      </Suspense>
    </AppContext.Provider>
  );
}

export default App;
